'use strict';

export default function f($window, $rootScope, $compile, scrollbarWidth, bodyScroll) {
  'ngInject';

  var bodyEl = angular.element($window.document.body);
  var wrapperEl = angular.element($window.document.querySelector('.Wrapper'));
  var slideshowEl;
  var slideshow;

  slideshow = {
    show: function (photos, initialPhotoIndex = 0, options = {}) {
      var scrollWidth = scrollbarWidth();
      var scope = $rootScope.$new();

      if (slideshowEl) {
        return;
      }

      scope.photos = photos;
      scope.initialPhotoIndex = initialPhotoIndex;
      scope.edit = options.edit;
      scope.isCounterVisible = options.isCounterVisible !== false;
      slideshowEl = $compile('<slideshow photos="photos" initial-photo-index="initialPhotoIndex" edit="edit" is-counter-visible="isCounterVisible"></slideshow>')(scope);
      wrapperEl.css('padding_right', scrollWidth + 'px');
      bodyEl.css('padding_right', scrollWidth + 'px');
      bodyScroll.disable();
      bodyEl.append(slideshowEl);
      this.isVisible = true;

      this.unbindListener = $rootScope.$on('$stateChangeSuccess', () => {
        this.hide();
      });
    },

    hide: function () {
      if (!slideshowEl) {
        return;
      }

      slideshowEl.remove();
      wrapperEl.css('padding_right', 0);
      bodyEl.css('padding_right', 0);
      bodyScroll.enable();

      slideshowEl = null;
      delete this.isVisible;
      this.unbindListener();
    }
  };

  return slideshow;
}



// WEBPACK FOOTER //
// ./app/src/common/slideshow/slideshow.service.js